import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigateToTop } from "../../../libs/useNavigateToTop";
import AppBarMenu from "../Menu";
import AppBarRoot from "../Root";
import { SaveButtonFull } from "../../SaveButton";

function AppBarDesignerEditSite({ onSaveSite, client, siteName }) {
  //state for saving
  const [isSaving, setIsSaving] = React.useState(false);
  const navigate = useNavigateToTop();

  const handleSaveSuccess = () => {
    setIsSaving(false);
  };

  const handleSaveError = (error) => {
    setIsSaving(false);
    alert(error);
  };

  const handleOnSave = () => {
    setIsSaving(true);
    onSaveSite({}, handleSaveSuccess, handleSaveError);
  };

  return (
    <AppBarRoot
      startAction={
        <Stack direction={"row"} spacing={2}>
          <AppBarMenu />
          {/* <Typography
            onClick={() => navigate("/")}
            variant="h5"
            style={{ alignSelf: "center", color: "white" }}
          >
            Local Bonsai
          </Typography> */}
        </Stack>
      }
      centerAction={
        <Typography variant="" style={{ alignSelf: "center", color: "white" }}>
          {client}/{siteName}
        </Typography>
      }
      endAction={
        <Stack direction={"row"} spacing={1}>
          <SaveButtonFull
            title="Save Site"
            onClick={handleOnSave}
            saving={isSaving}
          />
        </Stack>
      }
    />
  );
}

export default AppBarDesignerEditSite;
